import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-error" }
const _hoisted_2 = { class: "flex align-items-center" }
const _hoisted_3 = { class: "ml-2 text-color-red-dark" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "p-error" }
const _hoisted_6 = { class: "flex flex-column" }
const _hoisted_7 = { class: "flex align-items-center gap-1" }
const _hoisted_8 = { class: "flex flex-column gap-1" }
const _hoisted_9 = { class: "flex align-items-center" }
const _hoisted_10 = { class: "flex align-items-center" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "p-error" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "p-error" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "p-error" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "p-error" }
const _hoisted_19 = { key: 1 }

import { computed, toRefs } from 'vue';
import { useOrganizationContractsStore } from '@/store';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputNumber from 'primevue/inputnumber';
import InputSwitch from 'primevue/inputswitch';
import RadioButton from 'primevue/radiobutton';
import Message from 'primevue/message';
import { ContractTherapyEvaluationTypeInterface } from '@/types';
import useVuelidate from '@vuelidate/core';
import { helpers, requiredIf } from '@vuelidate/validators';
import { can, useDateTime } from '@/composables';
import { PERMISSIONS } from '@/enum';

interface Props {
  scope: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OrganizationContractEvaluations',
  props: {
    scope: {}
  },
  setup(__props: any) {

const props = __props;

const { scope } = toRefs(props);

const organizationContractsStore = useOrganizationContractsStore();

const isToggledOn = (v: string, data: ContractTherapyEvaluationTypeInterface) => {
  return !!data.toggle;
};

const rules = computed(() => {
  return {
    evaluations: {
      $each: helpers.forEach({
        toggle: {},
        window_length: {
          requiredIfCustom: helpers.withMessage('Window Length of 0 or greater is required', requiredIf(isToggledOn)),
        },
        noshow_rate: {
          requiredIfCustom: helpers.withMessage('No Show of 0 or greater is required', requiredIf(isToggledOn)),
        },
        rate: {
          requiredIfCustom: helpers.withMessage('Rate of 0 or greater is required', requiredIf(isToggledOn)),
        },
        pre_purchased: {
          requiredIfCustom: helpers.withMessage('Pre Purchased of 0 or greater is required', requiredIf(isToggledOn)),
        },
        included: {
          requiredIfCustom: helpers.withMessage('Included Evals of 0 or greater is required', requiredIf(isToggledOn)),
        },
      }),
    },
  };
});

const v$ = useVuelidate(
  rules,

  { evaluations: organizationContractsStore.contractEvaluationTypes },
  { $scope: scope.value },
);

const onToggleChange = async (data: ContractTherapyEvaluationTypeInterface) => {
  data.disabled = !data.toggle;
  if (data.disabled === true) checkToggleCount(data);
  else {
    resetValidSetting();
  }

  await checkEventToRemove(data);
};

const checkEventToRemove = async (data: ContractTherapyEvaluationTypeInterface): Promise<void> => {
  const id = data.therapy_evaluation_type_id;

  if (
    !organizationContractsStore.contract?.id ||
    !organizationContractsStore.isToggleTrueInOriginalEvaluationsTypes(id)
  )
    return;

  if (data.toggle) {
    setEventRemoval(id, undefined);
    return;
  }

  const { events_count = 0 } = await organizationContractsStore.checkEventToRemove({ evaluation_type_id: id });
  setEventRemoval(id, events_count > 0 ? events_count : undefined);
};

const setEventRemoval = (id: number, value: number | undefined) => {
  organizationContractsStore.$patch((state) => {
    const found = state.contractEvaluationTypes.find((e) => e.therapy_evaluation_type_id === id);
    if (found && found.event_removal !== value) {
      found.event_removal = value;
    }
  });
};

//here we check to see if all toggles are off and if so set an error
const checkToggleCount = (data: ContractTherapyEvaluationTypeInterface) => {
  const count = organizationContractsStore.contractEvaluationTypes.find(
    (evaluation: ContractTherapyEvaluationTypeInterface) => evaluation.toggle,
  );

  if (!!count === false) data.isValid = false;
};

/**
 * if at least one toggle is on then all is valid
 */
const resetValidSetting = () => {
  organizationContractsStore.contractEvaluationTypes.forEach((evaluation: ContractTherapyEvaluationTypeInterface) => {
    evaluation.isValid = true;
  });
};

const checkNoShowType = (data: ContractTherapyEvaluationTypeInterface) => {
  if (!data.noshow_rate_is_fixed && data.noshow_rate > 100) {
    data.noshow_rate = 100;
  }
};

const maxNoShow = (data: ContractTherapyEvaluationTypeInterface) => {
  return data.noshow_rate_is_fixed ? 10000 : 100;
};

const checkNoShowTypeMode = (noshow_rate_is_fixed: boolean) => {
  return noshow_rate_is_fixed ? 'currency' : 'decimal';
};

const canEdit = computed(() => {
  return can([PERMISSIONS.CONTRACTEVALUATION_UPDATE]);
});

// Usage example:

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_unref(organizationContractsStore).contractEvaluationTypes.length)
    ? (_openBlock(), _createBlock(_unref(DataTable), {
        key: 0,
        value: _unref(organizationContractsStore).contractEvaluationTypes,
        loading: _unref(organizationContractsStore).loading,
        "row-key": 'therapy_evaluation_type_id',
        class: "p-datatable-gridlines"
      }, {
        header: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "flex mb-1" }, [
            _createElementVNode("p", null, [
              _createElementVNode("b", null, "Evaluations")
            ])
          ], -1)
        ]))]),
        default: _withCtx(() => [
          _createVNode(_unref(Column), { style: {"width":"6%"} }, {
            body: _withCtx((slotProps) => [
              _createVNode(_unref(InputSwitch), {
                modelValue: slotProps.data.toggle,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.toggle) = $event),
                class: _normalizeClass({
            'p-invalid': !!_unref(v$).evaluations.$each.$response?.$errors?.[slotProps.index]?.isValid?.$invalid,
          }),
                disabled: !canEdit.value,
                onChange: ($event: any) => (onToggleChange(slotProps.data))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "disabled", "onChange"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).evaluations.$each.$response?.$errors?.[slotProps.index]?.isValid ?? [], (error, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "input-errors"
                }, [
                  _createElementVNode("div", _hoisted_1, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "title",
            header: "Type",
            style: {"width":"20%"},
            "body-class": "wrap-cell"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.data.title), 1),
              (slotProps.data.event_removal && slotProps.data.event_removal > 0)
                ? (_openBlock(), _createBlock(_unref(Message), {
                    key: 0,
                    closable: false,
                    class: "contract-date-notice border-primary justify-content-start my-1",
                    severity: "warn",
                    icon: "none"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_Icon, {
                          name: "warning",
                          class: "text-color-yellow-dark text-lg align-self-start"
                        }),
                        _createElementVNode("p", _hoisted_3, [
                          _cache[1] || (_cache[1] = _createTextVNode(" Turning off the toggle will remove ", -1)),
                          _createElementVNode("b", null, _toDisplayString(slotProps.data.event_removal), 1),
                          _cache[2] || (_cache[2] = _createTextVNode(" scheduled events for this evaluation type. ", -1)),
                          _createElementVNode("b", null, _toDisplayString(_unref(useDateTime)().formatIntlDate(_unref(organizationContractsStore).contract.start_at)) + " - " + _toDisplayString(_unref(useDateTime)().formatIntlDate(_unref(organizationContractsStore).contract.end_at)), 1),
                          _cache[3] || (_cache[3] = _createTextVNode(" . ", -1))
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            header: "Flat Fee",
            style: {"width":"12%"}
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_unref(InputNumber), {
                modelValue: slotProps.data.rate,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.rate) = $event),
                class: _normalizeClass({
            'p-invalid': !!_unref(v$).evaluations.$each.$response?.$errors?.[slotProps.index]?.rate?.$invalid,
          }),
                mode: "currency",
                currency: "USD",
                disabled: !slotProps.data.toggle || !canEdit.value,
                min: 0,
                onBlur: _unref(v$).$touch
              }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "disabled", "onBlur"]),
              (slotProps.data.toggle)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).evaluations.$each.$response?.$errors?.[slotProps.index]?.rate ?? [], (error, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "input-errors"
                      }, [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(error.$message), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            header: "No Show / Late Cancel %/$",
            style: { width: '20%' }
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_unref(InputNumber), {
                    modelValue: slotProps.data.noshow_rate,
                    "onUpdate:modelValue": ($event: any) => ((slotProps.data.noshow_rate) = $event),
                    mode: checkNoShowTypeMode(!!slotProps.data.noshow_rate_is_fixed),
                    currency: "USD",
                    disabled: !slotProps.data.toggle || !canEdit.value,
                    class: _normalizeClass({
                'p-invalid': !!_unref(v$).evaluations.$each.$response?.$errors?.[slotProps.index]?.noshow_rate?.$invalid,
              }),
                    min: 0,
                    max: maxNoShow(slotProps.data),
                    onBlur: _unref(v$).$touch,
                    onInput: ($event: any) => (checkNoShowType(slotProps.data))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "mode", "disabled", "class", "max", "onBlur", "onInput"]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_unref(RadioButton), {
                        modelValue: slotProps.data.noshow_rate_is_fixed,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.noshow_rate_is_fixed) = $event),
                        value: true,
                        disabled: !slotProps.data.toggle || !canEdit.value,
                        onChange: ($event: any) => (checkNoShowType(slotProps.data))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"]),
                      _cache[4] || (_cache[4] = _createElementVNode("label", { class: "ml-2" }, "$", -1))
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_unref(RadioButton), {
                        modelValue: slotProps.data.noshow_rate_is_fixed,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.noshow_rate_is_fixed) = $event),
                        value: false,
                        disabled: !slotProps.data.toggle || !canEdit.value,
                        onChange: ($event: any) => (checkNoShowType(slotProps.data))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"]),
                      _cache[5] || (_cache[5] = _createElementVNode("label", { class: "ml-2" }, "%", -1))
                    ])
                  ])
                ]),
                (slotProps.data.toggle)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).evaluations.$each.$response?.$errors?.[slotProps.index]?.noshow_rate ?? [], (error, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: i,
                          class: "input-errors"
                        }, [
                          _createElementVNode("div", _hoisted_12, _toDisplayString(error.$message), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            header: "Window",
            style: {"width":"11%"}
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_unref(InputNumber), {
                modelValue: slotProps.data.window_length,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.window_length) = $event),
                disabled: !slotProps.data.toggle || !canEdit.value,
                class: _normalizeClass({
            'p-invalid': !!_unref(v$).evaluations.$each.$response?.$errors?.[slotProps.index]?.window_length?.$invalid,
          }),
                min: 0,
                onBlur: _unref(v$).$touch
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "class", "onBlur"]),
              (slotProps.data.toggle)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).evaluations.$each.$response?.$errors?.[slotProps.index]?.window_length ?? [], (error, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "input-errors"
                      }, [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(error.$message), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            header: "Pre Purchased",
            style: {"width":"13%"}
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_unref(InputNumber), {
                modelValue: slotProps.data.pre_purchased,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.pre_purchased) = $event),
                disabled: !slotProps.data.toggle || !canEdit.value,
                class: _normalizeClass({
            'p-invalid': !!_unref(v$).evaluations.$each.$response?.$errors?.[slotProps.index]?.pre_purchased?.$invalid,
          }),
                min: 0,
                onBlur: _unref(v$).$touch
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "class", "onBlur"]),
              (slotProps.data.toggle)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).evaluations.$each.$response?.$errors?.[slotProps.index]?.pre_purchased ?? [], (error, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "input-errors"
                      }, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(error.$message), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            header: "Included Evals",
            style: {"width":"13%"}
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_unref(InputNumber), {
                modelValue: slotProps.data.included,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.included) = $event),
                disabled: !slotProps.data.toggle || !canEdit.value,
                class: _normalizeClass({
            'p-invalid': !!_unref(v$).evaluations.$each.$response?.$errors?.[slotProps.index]?.included?.$invalid,
          }),
                min: 0,
                "max-fraction-digits": 0,
                onBlur: _unref(v$).$touch
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "class", "onBlur"]),
              (slotProps.data.toggle)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).evaluations.$each.$response?.$errors?.[slotProps.index]?.included ?? [], (error, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "input-errors"
                      }, [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(error.$message), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "loading"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_19, "...Loading"))
}
}

})